import React from 'react';
import CategorySection from '../CategorySection/CategorySection';
import './Categories.css';

const Categories = () => {
  const birthdayProducts = [
    {
      image: '/images/BirthdayImages/freepik__35mm-film-photography-luxury-indian-birthday-decor__13647.webp',
      title: 'Premium Birthday Decor',
      currentPrice: '1,999',
      originalPrice: '2,499',
      discount: 20
    },
    {
      image: '/images/BirthdayImages/freepik__35mm-film-photography-premium-birthday-decoration-__13643.webp',
      title: 'Luxury Birthday Setup',
      currentPrice: '2,299',
      originalPrice: '2,799',
      discount: 18
    },
    {
      image: '/images/BirthdayImages/freepik__35mm-film-photography-premium-home-garden-birthday__13646.webp',
      title: 'Elegant Home Birthday',
      currentPrice: '2,499',
      originalPrice: '2,999',
      discount: 17
    },
    {
      image: '/images/BirthdayImages/freepik__the-style-is-candid-image-photography-with-natural__13644.webp',
      title: 'Natural Style Birthday',
      currentPrice: '1,799',
      originalPrice: '2,199',
      discount: 18
    }
  ];

  const kidsBirthdayProducts = [
    {
      image: '/images/KidBirthdayDecorations/freepik__35mm-film-photography-organic-balloon-garland-circ__76740.webp',
      title: 'Fun Kids Theme Decor',
      currentPrice: '2,299',
      originalPrice: '2,799',
      discount: 18
    },
    {
      image: '/images/KidBirthdayDecorations/freepik__35mm-film-photography-premium-marvel-superheroes-t__76739.webp',
      title: 'Marvel Superhero Theme',
      currentPrice: '2,499',
      originalPrice: '2,999',
      discount: 17
    },
    {
      image: '/images/KidBirthdayDecorations/freepik__the-style-is-candid-image-photography-with-natural__76738.webp',
      title: 'Natural Kids Party',
      currentPrice: '2,099',
      originalPrice: '2,499',
      discount: 16
    },
    {
      image: '/images/KidBirthdayDecorations/Gemini_Generated_Image_dnendnendnendnen.webp',
      title: 'Colorful Kids Celebration',
      currentPrice: '2,199',
      originalPrice: '2,699',
      discount: 19
    }
  ];

  const anniversaryProducts = [
    {
      image: '/images/AnniversaryImages/Gemini_Generated_Image_4nhb0q4nhb0q4nhb.webp',
      title: 'Romantic Anniversary Setup',
      currentPrice: '2,499',
      originalPrice: '2,999',
      discount: 17
    },
    {
      image: '/images/AnniversaryImages/Gemini_Generated_Image_bl2lg6bl2lg6bl2l.webp',
      title: 'Elegant Anniversary Decor',
      currentPrice: '2,299',
      originalPrice: '2,799',
      discount: 18
    },
    {
      image: '/images/AnniversaryImages/Gemini_Generated_Image_p740z7p740z7p740.webp',
      title: 'Luxury Anniversary Theme',
      currentPrice: '2,699',
      originalPrice: '3,199',
      discount: 16
    },
    {
      image: '/images/AnniversaryImages/Gemini_Generated_Image_wdkjmtwdkjmtwdkj.webp',
      title: 'Romantic Bliss Setup',
      currentPrice: '2,399',
      originalPrice: '2,899',
      discount: 17
    }
  ];

  const babyShowerProducts = [
    {
      image: '/images/BabyShower/Gemini_Generated_Image_2e5abf2e5abf2e5a.webp',
      title: 'Elegant Baby Shower Theme',
      currentPrice: '3,499',
      originalPrice: '3,999',
      discount: 13
    },
    {
      image: '/images/BabyShower/Gemini_Generated_Image_39tdbz39tdbz39td.webp',
      title: 'Dreamy Baby Shower Setup',
      currentPrice: '3,699',
      originalPrice: '4,199',
      discount: 12
    },
    {
      image: '/images/BabyShower/Gemini_Generated_Image_j7otzmj7otzmj7ot.webp',
      title: 'Luxury Baby Shower Decor',
      currentPrice: '3,899',
      originalPrice: '4,499',
      discount: 13
    },
    {
      image: '/images/BabyShower/Gemini_Generated_Image_t2qxk9t2qxk9t2qx.webp',
      title: 'Beautiful Baby Shower Theme',
      currentPrice: '3,299',
      originalPrice: '3,799',
      discount: 13
    }
  ];

  return (
    <section id="categories" className="categories">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Our Decoration Collections</h2>
          <p className="section-subtitle">Discover our exquisite range of decoration themes</p>
        </div>

        <CategorySection title="Birthday Decorations" products={birthdayProducts} />
        <CategorySection title="Kids Birthday Decorations" products={kidsBirthdayProducts} />
        <CategorySection title="Anniversary Decorations" products={anniversaryProducts} />
        <CategorySection title="Baby Shower Decorations" products={babyShowerProducts} />
      </div>
    </section>
  );
};

export default Categories;
